import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"
import store from "@/store"

Vue.use(VueRouter)

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
    meta: { guest: true },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("../views/ResetPassword.vue"),
    meta: { guest: true },
  },
  {
    path: "/reset-password/:uid/:token/",
    name: "ResetPasswordConfirm",
    component: () => import("../views/ResetPasswordConfirm.vue"),
    meta: { guest: true },
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { auth: true },
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/About.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/people",
    name: "People",
    component: () => import("../views/People/List.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/people/new",
    name: "NewPerson",
    component: () => import("../views/People/Create.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/people/:id",
    name: "EditPerson",
    component: () => import("../views/People/Update.vue"),
    meta: { auth: true },
  },
  //
  {
    path: "/registry/categories",
    name: "PersonCategories",
    component: () => import("../views/PersonCategories/List.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/categories/new",
    name: "NewPersonCategory",
    component: () => import("../views/PersonCategories/Create.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/categories/:id",
    name: "EditPersonCategory",
    component: () => import("../views/PersonCategories/Update.vue"),
    meta: { auth: true },
  },
  //
  {
    path: "/registry/roles",
    name: "PersonRoles",
    component: () => import("../views/PersonRoles/List.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/roles/new",
    name: "NewPersonRole",
    component: () => import("../views/PersonRoles/Create.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/roles/:id",
    name: "EditPersonRole",
    component: () => import("../views/PersonRoles/Update.vue"),
    meta: { auth: true },
  },
  //
  {
    path: "/registry/bands",
    name: "Bands",
    component: () => import("../views/Bands/List.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/bands/new",
    name: "NewBand",
    component: () => import("../views/Bands/Create.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/bands/:id",
    name: "EditBand",
    component: () => import("../views/Bands/Update.vue"),
    meta: { auth: true },
  },
  //
  {
    path: "/registry/transport-companies",
    name: "TransportCompanies",
    component: () => import("../views/TransportCompanies/List.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/transport-companies/new",
    name: "NewTransportCompany",
    component: () => import("../views/TransportCompanies/Create.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/transport-companies/:id",
    name: "EditTransportCompany",
    component: () => import("../views/TransportCompanies/Update.vue"),
    meta: { auth: true },
  },
  //
  {
    path: "/registry/hotels",
    name: "Hotels",
    component: () => import("../views/Hotels/List.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/hotels/new",
    name: "NewHotel",
    component: () => import("../views/Hotels/Create.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/hotels/:id",
    name: "EditHotel",
    component: () => import("../views/Hotels/Update.vue"),
    meta: { auth: true },
  },
  //
  {
    path: "/registry/rooms",
    name: "Rooms",
    component: () => import("../views/Rooms/List.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/rooms/new",
    name: "NewRoom",
    component: () => import("../views/Rooms/Create.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/rooms/:id",
    name: "EditRoom",
    component: () => import("../views/Rooms/Update.vue"),
    meta: { auth: true },
  },
  //
  {
    path: "/registry/instruments",
    name: "Instruments",
    component: () => import("../views/Instruments/List.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/instruments/new",
    name: "NewInstrument",
    component: () => import("../views/Instruments/Create.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/instruments/:id",
    name: "EditInstrument",
    component: () => import("../views/Instruments/Update.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/places",
    name: "Places",
    component: () => import("../views/Places/List.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/places/new",
    name: "NewPlace",
    component: () => import("../views/Places/Create.vue"),
    meta: { auth: true },
  },
  {
    path: "/registry/places/:id",
    name: "EditPlace",
    component: () => import("../views/Places/Update.vue"),
    meta: { auth: true },
  },
  {
    path: "/tools/export-events",
    name: "ExportEvents",
    component: () => import("../views/Tools/ExportEvents.vue"),
    meta: { auth: true },
  },
  {
    path: "/editions/shows",
    name: "Shows",
    component: () => import("../views/Shows/List.vue"),
    meta: { auth: true },
  },
  {
    path: "/editions/shows/new",
    name: "NewShow",
    component: () => import("../views/Shows/Create.vue"),
    meta: { auth: true },
  },
  {
    path: "/editions/shows/:id",
    component: () => import("../views/Shows/Update.vue"),
    meta: { auth: true },
    children: [
      {
        path: "",
        name: "EditShow",
        component: () => import("../views/Shows/UpdateDetails.vue"),
      },
      {
        path: "calendar",
        name: "ShowCalendar",
        component: () => import("../views/Shows/Calendar.vue"),
      },
      {
        path: "bands",
        name: "ShowBands",
        component: () => import("../views/Shows/UpdateBands.vue"),
      },
      {
        path: "concert-categories",
        name: "ShowConcertCategories",
        component: () => import("../views/Shows/UpdateConcertCategories.vue"),
      },
      {
        path: "concerts",
        name: "ShowConcerts",
        component: () => import("../views/Shows/UpdateConcerts.vue"),
      },
      {
        path: "events",
        name: "ShowEvents",
        component: () => import("../views/Shows/UpdateEvents.vue"),
      },
      {
        path: "instruments",
        name: "ShowInstruments",
        component: () => import("../views/Shows/UpdateInstruments.vue"),
      },
      {
        path: "instruments/export/:instrumentId",
        name: "ExportInstrument",
        component: () => import("../views/Shows/ExportInstrument.vue"),
      },
      {
        path: "people",
        name: "ShowPeople",
        component: () => import("../views/Shows/UpdatePeople.vue"),
      },
      {
        path: "people/export/:personId/:showPersonId",
        name: "ExportPerson",
        component: () => import("../views/Shows/ExportPerson.vue"),
      },
      {
        path: "places",
        name: "ShowPlaces",
        component: () => import("../views/Shows/UpdatePlaces.vue"),
      },
      {
        path: "places/export/:placeId",
        name: "ExportPlace",
        component: () => import("../views/Shows/ExportPlace.vue"),
      },
      {
        path: "person-options",
        name: "ShowPersonOptions",
        component: () => import("../views/Shows/ShowPersonOptions.vue"),
      },
      {
        path: "export",
        name: "ShowExport",
        component: () => import("../views/Shows/Export.vue"),
      },
      {
        path: "transports",
        name: "ShowTransports",
        component: () => import("../views/Shows/UpdateTransports.vue"),
      },
      {
        path: "vouchers",
        name: "ShowVouchers",
        component: () => import("../views/Shows/UpdateVouchers.vue"),
      },
      {
        path: "aggregated-data",
        name: "ShowAggregatedData",
        component: () => import("../views/Shows/AggregatedData.vue"),
      },
      {
        path: "hotels",
        name: "ShowHotels",
        component: () => import("../views/Shows/UpdateHotels.vue"),
        props: true,
      },
      {
        path: "rooms",
        name: "ShowRooms",
        component: () => import("../views/Shows/UpdateRooms.vue"),
      },
      {
        path: "bookings",
        name: "ShowBookings",
        component: () => import("../views/Shows/UpdateBookings.vue"),
      },
      {
        path: "show-hotels-table-endpoint",
        name: "ShowHotelsTableEndpoint",
        component: () => import("../views/Shows/HotelsTableEndpoint.vue"),
      },
    ],
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((m) => m.meta.auth) && !store.getters.isAuthenticated) {
    /*
     * If the user is not isAuthenticated and visits
     * a page that requires authentication, redirect to the login page
     */
    next({
      name: "Login",
    })
  } else if (
    to.matched.some((m) => m.meta.guest) &&
    store.getters.isAuthenticated
  ) {
    /*
     * If the user is authenticated and visits
     * an guest page, redirect to the dashboard page
     */
    next({
      name: "Home",
    })
  } else {
    next()
  }
})

export default router
